import PageTitle from '../PageTitle'
import PageSubtitle from '../PageSubtitle'
import PrephysicianCardSmall from './PrephysicianCardSmall'

export default function PrephysicianGallery (props) {

  return(
    <div style={{display: 'flex', background: "#80a3db"}}>
      <div style={{width: '7vw'}}></div>
      <div style={{width: '86vw', marginBottom: '150px'}}>
        <div>
          <PageTitle
            pageTitle = 'Give your research project a boost'
            />
          <PageSubtitle
            pageSubtitle = 'Browse the cards below to find medical and premedical students who want to help'
            />
        </div>
        <div style = {{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}>
          {
            (
              props.prephysicianData &&
              props.prephysicianData.map(p => (
                <PrephysicianCardSmall
                  key={p.prephysician_id}
                  prephysician_id={p.prephysician_id}  
                  formal_name={p.formal_name}
                  state_name={p.state_name}
                  institution={p.institution}
                  skills={p.skills}
                  prephysicianModal={props.prephysicianModal}
                  setPrephysicianModal={props.setPrephysicianModal}
                />
              ))
            )
          }     
        </div>
       
      </div>
      <div style={{width: '7vw'}}></div>
    </div>
  )
}